import React, { useState } from 'react';
import Input from '../Common/Input';
import ReactSelect from 'react-select';

const Form = ({ formik, setOpinionFactorList, opinionFactorList }) => {

    return (
        <form onSubmit={formik.handleSubmit}>

            <div className="row">
        <div className="col-md-3">
                    <label >   معیار نظرسنجی   </label>
                    <ReactSelect
                        required
                        placeholder="انتخاب کنید"
                        options={opinionFactorList.filter(item => item.isActive === true)}
                        name="factorId"
                        isSearchable={true}
                        value={formik.values.factorId}
                        isRtl={true}
                        onChange={value => formik.setFieldValue("factorId", value)}
                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                    />
                </div>
                
                <div className="col-md-3" >
                    <Input label="عنوان" name="title" required={true} formik={formik} />

                </div>

        

            </div>


            <div className="row">
                <div className="col-md-12 mt-4 pt-4 text-center">
                    <button className="btn btn-success mx-auto text-center" id="btn-submit-form">ذخیره اطلاعات</button>
                </div>
            </div>

        </form >
    );

}

export default Form;


